import React from 'react';


// hook to store the previous value of a prop in a functional react component.
// This is the hook equivalent of the componentDidUpdate lifecycle method
// example use:
//   const myPrevProp = usePrevious(props.myProp, 0);
//   const myCurrentProp = props.myProp;
//   React.useEffect(
//     () => {
//       if (myCurrentProp !== myPrevProp) {
//         // ...
//       }
//     },
//     [myCurrentProp, myPrevProp]
//   );
export function usePrevious<T>(value: T, initialValue: T) {
  const ref = React.useRef<T>(initialValue);
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

/**
 * A simple hook which executes a React.useEffect only on mount despite the dependencies used by the fun provided
 *
 * @param fun the function to be exectuted be the useEffect hook
 * @param flags the optional flags whose change should allow the hook to be executed again
 */
export function useMountEffect(fun: () => void, ...flags: Array<unknown>) {
  React.useEffect(fun, [...flags]);
}
